import CtsAuthLibrary from "./ctsAuthLibrary"

export default class CTSRepository {
    organizationName = ""
    apiHost = ""
    apiStage = ""
    userToken = ""

    constructor(obj) {
        this.organizationName = obj.organization_id
        if (window.location.hostname.includes('gatewatch')) {
            this.apiHost = "https://74ow2locr0.execute-api.us-east-2.amazonaws.com"
            this.apiStage = "prod"
        } else {
            this.apiHost = "https://ufgow7hy1f.execute-api.us-east-2.amazonaws.com"
            this.apiStage = "dev"
        }
        this.userToken = new CtsAuthLibrary().getIdTokenCookie()
    }

    getApiUrl() {
        return `${this.apiHost}/${this.apiStage}`
    }

    getApiUrlForCommunity() {
        return `${this.getApiUrl()}/${this.organizationName}`
    }

    fetchSomething() {
        let url = `${this.getApiUrlForCommunity()}/`
        console.log(" Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log(" Data", data);
                    resolve(data.data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    createSomething(bodyString) {
        let url = `${this.getApiUrl()}/`
        console.log(" Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    fetchOrganizationData() {
        let url = `${this.getApiUrl()}/organizations/${this.organizationName}`
        console.log("Organization Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Organization Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    // Entry Log
    fetchEntryLog() {
        let url = `${this.getApiUrlForCommunity()}/entryLog`
        console.log("Entry Log URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Entry Log Data", data);
                    resolve(data.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    searchEntryLog(filters) {
        const isEmpty = Object.keys(filters).length === 0
        if (isEmpty) return this.fetchEntryLog()
        const queryString = new URLSearchParams(filters).toString();
        let url = `${this.getApiUrlForCommunity()}/entryLog/search?${queryString}`
        console.log("Entry Log Search URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Search Entry Log Data", data);
                    resolve(data.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    createEntryLog(params) {
        let url = `${this.getApiUrlForCommunity()}/entryLog`
        console.log("Entry Log URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: JSON.stringify(params)
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Entry Log Data", data);
                    resolve(data.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // Users

    fetchUser(userId) {
        return new Promise((resolve, reject) => {
            fetch(`${this.getApiUrlForCommunity()}/users/${userId}`,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${new CtsAuthLibrary().getIdTokenCookie()}`
                    },
                }
            ).then(
                (res) => res.json()
            ).then(data => {
                resolve(data)
            }).catch(err => reject(err))
        })

    }

    fetchResidents(data) {

        const url = `${this.getApiUrlForCommunity()}/users/search?first_name=${data}&last_name=${data}&address=${data}&email=${data}&phone_number=${data}&subdivision=${data}`
        const allUsersUrl = `${this.getApiUrlForCommunity()}/users`

        let finalUrl = url
        if (data == "") {
            finalUrl = allUsersUrl
        }

        console.log("Fetch Users Data URL", finalUrl)
        return new Promise((resolve, reject) => {
            fetch(
                finalUrl,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Fetch Users Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    searchResidents(data, filters) {

        let query = `first_name=${data}&last_name=${data}&address=${data}&email=${data}&phone_number=${data}&subdivision=${data}`

         for(const filter of Object.keys(filters)) {
            query = query + `&${filter}=${filters[filter]}`
        }


        const url = `${this.getApiUrlForCommunity()}/users/search?${query}`

        console.log("Fetch Users Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Fetch Users Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    createUser(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/users`
        console.log("Create User Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${new CtsAuthLibrary().getIdTokenCookie()}`
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create User Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    updateUser(userId, bodyString) {
        let url = `${this.getApiUrlForCommunity()}/users/${userId}`
        console.log("Update User Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `PATCH`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create User Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })

    }

    resendUserInvitation(userId) {
        let url = `${this.getApiUrlForCommunity()}/users/${userId}/resendUserInvitation`
        console.log("Update User Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Resend User Invitation Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })

    }

    fetchLocations() {
        let url = `${this.getApiUrlForCommunity()}/locations`
        console.log("Locations Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Locations Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    createIncident(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/incidents`
        console.log("Create Incident URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Incident Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })

    }

    searchIncidents(
        // search
    ) {
        let url = `${this.getApiUrlForCommunity()}/incidents`
        console.log("Incidents Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Incidents Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    fetchVehicles(search) {
        let url = search == "" ? `${this.getApiUrlForCommunity()}/vehicles/`
            : `${this.getApiUrlForCommunity()}/vehicles/`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then(data => resolve(data))
                .catch(err => reject(err))
        })
    }

    createVehicles(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/vehicles`
        console.log("Create Vehicle URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Vehicle Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    fetchVendors() {
        let url = `${this.getApiUrlForCommunity()}/vendors/`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    resolve(data)
                })
                .catch(err => reject(err))
        })
    }


    // Violations
    createViolation(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/violations`
        console.log("Create Violation Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Violation Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    fetchViolations() {
        let url = `${this.getApiUrlForCommunity()}/violations`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Get Violation Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }



    // Pets
    // TODO: Implement Create Pet Flows

    // Vendors
    createVendor(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/vendors`
        console.log("Create Vendor Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Vendor Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    // Keys
    fetchKey(keyId) {
        let url = `${this.getApiUrlForCommunity()}/keys/${keyId}`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    if (data.data.length == 0) {
                        reject("Key Not Found")
                    }
                    resolve(data.data[0]);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    fetchAllKeys() {
        let url = `${this.getApiUrlForCommunity()}/keys`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getStartOfTomorrowUTC() {
        const now = new Date();
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


        // Get today's date parts in the user's timezone
        const parts = new Intl.DateTimeFormat("en-CA", {
            timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        }).formatToParts(now);

        const year = parts.find(p => p.type === "year").value;
        const month = parts.find(p => p.type === "month").value;
        const day = parts.find(p => p.type === "day").value;

        // Build "today midnight" in that timezone
        const todayLocalMidnight = new Date(`${year}-${month}-${day}T00:00:00`);

        // Move to tomorrow midnight (still in that timezone context)
        const tomorrowLocalMidnight = new Date(todayLocalMidnight);
        tomorrowLocalMidnight.setDate(tomorrowLocalMidnight.getDate() + 1);

        // Convert to UTC string
        return tomorrowLocalMidnight.toISOString();
    }

    searchKeys(filters) {
        const queryString = new URLSearchParams(filters).toString();
        let url = `${this.getApiUrlForCommunity()}/keys/search?${queryString}`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json()).then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getIncomingVisitorsWidget(filters) {
        const queryString = new URLSearchParams(filters).toString();
        let url = `${this.getApiUrlForCommunity()}/keys/widget/incomingVisitors?${queryString}`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json()).then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    resendKey(keyId) {
        let url = `${this.getApiUrlForCommunity()}/keys/${keyId}/resend`
        console.log("Resend Key URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                    body: "",
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Resend Key Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    updateKey(keyId, bodyString) {
        let url = `${this.getApiUrlForCommunity()}/keys/${keyId}`
        console.log("Update Key URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `PATCH`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                    body: bodyString,
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Update Key Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    createKey(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/keys`
        console.log("Create Key Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Key Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    validateKey(keyId, bodyString) {
        let url = `${this.getApiUrlForCommunity()}/keys/${keyId}/validate`
        console.log("Validate Key URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Validate Key Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    // Visitor
    createVisitor(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/visitors`
        console.log("Create Visitor Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Visitor Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    fetchVisitorById(id) {
        let url = `${this.getApiUrlForCommunity()}/visitors/${id}`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    if (data.data.length == 0) {
                        reject("Visitor Not Found")
                    }
                    resolve(data.data[0]);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    fetchFrequentVisitors(data, filters, limit, page) {
        let query = `visitorType=Frequent%20Visitor`
        if (data != "" && data != null) {
            query = query + `&name=${data}`
        }
        for(const filter of Object.keys(filters)) {
            query = query + `&${filter}=${filters[filter]}`
        }
        let url = `${this.getApiUrlForCommunity()}/visitors/search?${query}&limit=${limit ?? 100}&page=${page ?? 1}`
        console.log("Frequent Visitor Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Frequent Visitor Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    fetchBlockedVisitors() {
        let url = `${this.getApiUrlForCommunity()}/visitors/search?visitorStatus=BLOCKED`
        console.log("Blocked Visitor Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Blocked Visitor Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    updateVisitor(id, bodyString) {
        let url = `${this.getApiUrlForCommunity()}/visitors/${id}`
        console.log("Update Visitor Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `PATCH`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Update Visitor Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    // Maintenance

    createMaintenanceOrder(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/maintenance`
        console.log("Create Maintenance Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Maintenance Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    getAllMaintenanceOrders() {
        let url = `${this.getApiUrlForCommunity()}/maintenance`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    // Units
    fetchUnits(unitId) {
        let url = `${this.getApiUrlForCommunity()}/units/${unitId}`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    if (data.data.length == 0) {
                        reject("Unit Not Found")
                    }
                    resolve(data.data[0]);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    fetchAllUnits() {
        let url = `${this.getApiUrlForCommunity()}/units`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    resolve(data.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    searchUnits(query, filters) {
        const isEmpty = Object.keys(filters).length === 0
        if (isEmpty) return this.fetchAllUnits()
        const queryString = new URLSearchParams(filters).toString();

        let url = `${this.getApiUrlForCommunity()}/units/search?${queryString}`
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `GET`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                }
            )
                .then((res) => res.json()).then((data) => {
                    resolve(data.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    createUnit(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/units`
        console.log("Create Unit Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Unit Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    // Emergency Contacts
    createEmergencyContact(bodyString) {
        let url = `${this.getApiUrlForCommunity()}/emergencyContacts`
        console.log("Create Emergency Contact Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `POST`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Create Emergency Contact Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

    updateEmergecyContact(id, bodyString) {
        let url = `${this.getApiUrlForCommunity()}/emergencyContacts/${id}`
        console.log("Update Emergency Contact Data URL", url)
        return new Promise((resolve, reject) => {
            fetch(
                url,
                {
                    method: `PATCH`,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${this.userToken}`
                    },
                    body: bodyString
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log("Update Emergency Contact Data", data);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        })
    }

}